export async function waitForMockDelay(multiplier?: number): Promise<void> {
  const mockDelay = parseInt(import.meta.env.VITE_API_MOCK_DELAY || '0', 10);
  if (!mockDelay) {
    return;
  }
  await new Promise((resolve) => setTimeout(resolve, mockDelay * (multiplier || 1)));
}
